import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import idx from "idx";
import {
  getGlobalSetting,
  editGlobalSetting,
  getGlobalSettingReducer,
} from "../../actions/global-setting.action";
import { errorSnackBar } from "../../actions/common.action";
import "./scss/templates.scss";
import { withRouter } from "../../util/with-router";
import CustomInput from "../../components/inputs/new-input";
import SelectInput from "../../components/inputs/select";
import TextAreaInput from "../../components/inputs/textarea-input";
import Button from 'react-bootstrap/Button';
import Modal from "../../components/modal/modal";
import Form from 'react-bootstrap/Form';
import _ from "lodash";
import { ValidatorTypes, ValidateField } from "../../util/validators";

class FinanceSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        finance_accountName: {
          name: "finance_accountName",
          label: "Account Name",
          type: "text",
          touched: false,
          error: false,
          valid: true,
          value: "",
          dataCy: "account-name-input",
          validation: [ValidatorTypes.REQUIRED],
        },
        finance_bsb: {
          name: "finance_bsb",
          label: "BSB",
          type: "text",
          touched: false,
          error: false,
          valid: true,
          value: "",
          dataCy: "bsb-input",
          validation: [ValidatorTypes.REQUIRED],
        },
        finance_accountNo: {
          name: "finance_accountNo",
          label: "Account No",
          type: "text",
          touched: false,
          error: false,
          valid: true,
          value: "",
          dataCy: "account-no-input",
          validation: [ValidatorTypes.REQUIRED],
        },
        finance_remittance: {
          name: "finance_remittance",
          label: "Remittance Email",
          type: "email",
          touched: false,
          error: false,
          valid: true,
          value: "",
          dataCy: "remittance-email-input",
          validation: [ValidatorTypes.REQUIRED, ValidatorTypes.EMAIL],
        },
        finance_invoiceNo: {
          name: "finance_invoiceNo",
          label: "Invoice Start Number",
          type: "number",
          touched: false,
          error: false,
          valid: true,
          value: "",
          dataCy: "invoice-start-number-input",
          validation: [ValidatorTypes.REQUIRED],
        },
        finance_purchaseOrderNo: {
          name: "finance_purchaseOrderNo",
          label: "Purchase Order Start Number",
          type: "number",
          touched: false,
          error: false,
          valid: true,
          value: "",
          dataCy: "purchase-order-start-number-input",
          validation: [ValidatorTypes.REQUIRED],
        },
        finance_customerNo: {
          name: "finance_customerNo",
          label: "Customer Start Number",
          type: "number",
          touched: false,
          error: false,
          valid: true,
          value: "",
          dataCy: "customer-start-number-input",
          validation: [ValidatorTypes.REQUIRED],
        },
        finance_vendorNo: {
          name: "finance_vendorNo",
          label: "Vendor Start Number",
          type: "number",
          touched: false,
          error: false,
          valid: true,
          value: "",
          dataCy: "vendor-start-number-input",
          validation: [ValidatorTypes.REQUIRED],
        },
        finance_projectNo: {
          name: "finance_projectNo",
          label: "Project Start Number",
          type: "number",
          touched: false,
          error: false,
          valid: true,
          value: "",
          dataCy: "project-start-number-input",
          validation: [ValidatorTypes.REQUIRED],
        },
        // Simple Quarter Configuration Fields
        finance_fiscal_year_start_month: {
          name: "finance_fiscal_year_start_month",
          label: "Fiscal Year Starts In",
          type: "select",
          touched: false,
          error: false,
          valid: true,
          value: "1", // Default to January
          items: [
            { key: "January", value: "1" },
            { key: "February", value: "2" },
            { key: "March", value: "3" },
            { key: "April", value: "4" },
            { key: "May", value: "5" },
            { key: "June", value: "6" },
            { key: "July", value: "7" },
            { key: "August", value: "8" },
            { key: "September", value: "9" },
            { key: "October", value: "10" },
            { key: "November", value: "11" },
            { key: "December", value: "12" }
          ],
          validation: [ValidatorTypes.REQUIRED],
        },
        finance_months_per_quarter: {
          name: "finance_months_per_quarter",
          label: "Months per Quarter",
          type: "number",
          touched: false,
          error: false,
          valid: true,
          step: 1,
          value: "3", // Default to 3 months
          placeholder: "Enter number of months (1-6)",
          min: "1",
          max: "6",
          validation: [ValidatorTypes.REQUIRED, ValidatorTypes.MONTHS_PER_QUARTER],
        },
        // Act Text and Placement fields for Australian invoices
        finance_act_text: {
          name: "finance_act_text",
          label: "Act Text",
          type: "textarea",
          touched: false,
          error: false,
          valid: true,
          value: "",
          dataCy: "act-text-input",
          validation: [ValidatorTypes.REQUIRED],
          rows: 3,
        },
        finance_act_placement: {
          name: "finance_act_placement",
          label: "Placement",
          type: "radio",
          touched: false,
          error: false,
          valid: true,
          value: "left",
          dataCy: "act-placement-radio",
          validation: [ValidatorTypes.REQUIRED],
        },
        finance_show_retentions: {
          name: "finance_show_retentions",
          label: "Show Retention",
          type: "checkbox",
          touched: false,
          error: false,
          valid: true,
          value: false,
          dataCy: "show-retentions-checkbox",
          validation: [],
        },
        finance_show_variations: {
          name: "finance_show_variations",
          label: "Show Variation",
          type: "checkbox",
          touched: false,
          error: false,
          valid: true,
          value: false,
          dataCy: "show-variations-checkbox",
          validation: [],
        },
      },
      initialVisibility: {
        showRetentions: false,
        showVariations: false,
      },
      showPropagationModal: false,
      propagationContext: null,
    };
  }

  componentDidMount() {
    this.getFinanceSetting();
  }

  getFinanceSetting = async () => {
    let { fields } = this.state;
    await this.props.getGlobalSettingReducer("FINANCE_TAX");
    const financeData = idx(this.props.globalSetting, (_) => _.finance_tax) || {};

    financeData && Object.entries(financeData).forEach(([key, value]) => {
      if (key in fields) {
        const fieldConfig = fields[key];
        if (fieldConfig.type === "checkbox") {
          fieldConfig.value = value === true || value === "true";
        } else {
          fieldConfig.value = value ?? "";
        }
      }
    });

    const initialVisibility = {
      showRetentions: Boolean(idx(fields, _ => _.finance_show_retentions.value)),
      showVariations: Boolean(idx(fields, _ => _.finance_show_variations.value)),
    };

    this.setState({ fields, initialVisibility, propagationContext: null });
  };

  editFinanceSetting = async (propagateProjects = false) => {
    const { fields } = this.state;
    let isFormValid = true, dataToSend = {};

    fields && Object.entries(fields).forEach(([key, value]) => {
      const { error, valid } = ValidateField(value);
      fields[key].touched = true;
      fields[key].valid = valid;
      fields[key].error = error;
      isFormValid = isFormValid && valid;
      dataToSend[key] = value.value;
    });

    if (!isFormValid) {
      this.setState({ fields });
      return;
    }

    const financeData = idx(this.props.globalSetting, (_) => _.finance_tax) || {};
    delete financeData?.workingDays;
    const difference = _.difference(_.keys(financeData), _.keys(dataToSend));
    const companySettingTabFinanceData = _.pick(financeData, difference);
    const mergedObj = _.merge(dataToSend, companySettingTabFinanceData);
    dataToSend = mergedObj;

    if (propagateProjects) {
      dataToSend.propagateRetentionVisibility = true;
    }

    try {
      this.setState({ showPropagationModal: false, propagationContext: null });
      await this.props.editGlobalSetting(_.merge({}, dataToSend, companySettingTabFinanceData), "FINANCE_TAX");
      this.getFinanceSetting();
    } catch (error) {
      console.error(error);
    }
  };

  inputChangeHandler = (e, key) => {
    let fields = this.state.fields, isFormValid = true;
    const fieldConfig = fields[key];

    if (!fieldConfig) {
      return;
    }

    const value =
      fieldConfig.type === "checkbox" ? e.target.checked : e.target.value;

    fieldConfig.value = value;
    fieldConfig.touched = true;

    const { error, valid } = ValidateField({ value, validation: fieldConfig.validation });

    fieldConfig.error = error;
    fieldConfig.valid = valid;

    for (let fieldKey of Object.keys(fields)) {
      isFormValid = isFormValid && !fields[fieldKey].error;
    }

    this.setState({ fields, isFormValid });
  };

  radioChangeHandler = (e, key) => {
    let fields = this.state.fields, isFormValid = true;
    let value = e.target.value;

    fields[key].value = value;
    fields[key].touched = true;
    fields[key].error = false;
    fields[key].valid = true;

    for (let key of Object.keys(fields)) {
      isFormValid = isFormValid && !fields[key].error;
    }

    this.setState({ fields, isFormValid });
  };

  daysInputChangeHandler = (e, name = "") => {
    var value = e.target.checked || false;
    let fields = this.state.fields;
    fields.workingDays.days[name].value = value;
    fields.workingDays.touched = true;
    this.setState({ fields: fields });
  };

  handleValidation = ({ value = "", validation = [] }) => {
    let error = false, valid = true;
    ({ error, valid } = ValidateField({ value, validation }));

    return { error, valid }
  };

  handleFinanceSave = () => {
    const { fields, initialVisibility } = this.state;
    const nextRetention = Boolean(idx(fields, _ => _.finance_show_retentions.value));
    const nextVariation = Boolean(idx(fields, _ => _.finance_show_variations.value));
    const retentionChanged = nextRetention !== initialVisibility.showRetentions;
    const variationChanged = nextVariation !== initialVisibility.showVariations;

    if ((retentionChanged || variationChanged) && this.props.writePermission) {
      this.setState({
        showPropagationModal: true,
        propagationContext: {
          retentionChanged,
          variationChanged,
          nextRetention,
          nextVariation,
        },
      });
      return;
    }

    this.editFinanceSetting(false);
  };

  closePropagationModal = () => {
    this.setState({ showPropagationModal: false, propagationContext: null });
  };

  handlePropagationSkip = () => {
    this.setState(
      { showPropagationModal: false, propagationContext: null },
      () => this.editFinanceSetting(false)
    );
  };

  handlePropagationConfirm = () => {
    this.setState(
      { showPropagationModal: false, propagationContext: null },
      () => this.editFinanceSetting(true)
    );
  };

  render() {
    const { fields, showPropagationModal, propagationContext } = this.state;
    const writePermission = this.props.writePermission;

    const retentionSummary = propagationContext?.retentionChanged
      ? `Retention visibility will be ${propagationContext.nextRetention ? "enabled" : "disabled"}.`
      : null;
    const variationSummary = propagationContext?.variationChanged
      ? `Variation visibility will be ${propagationContext.nextVariation ? "enabled" : "disabled"}.`
      : null;

    const propagationModalContent = (
      <div className="propagation-modal-content">
        <p className="mb-3">
          Applying these visibility changes will update all existing projects to match the new system defaults.
          Do you want to proceed?
        </p>
        {(retentionSummary || variationSummary) && (
          <ul className="mb-3 ps-3">
            {retentionSummary && <li>{retentionSummary}</li>}
            {variationSummary && <li>{variationSummary}</li>}
          </ul>
        )}
        <div className="d-flex justify-content-end flex-wrap gap-2">
          <Button variant="outline-secondary" onClick={this.closePropagationModal} data-cy="visibility-propagation-cancel">
            Cancel
          </Button>
          <Button variant="secondary" onClick={this.handlePropagationSkip} data-cy="visibility-propagation-skip">
            Update System Only
          </Button>
          <Button className="secondarybtn" onClick={this.handlePropagationConfirm} data-cy="visibility-propagation-apply">
            Apply to All Projects
          </Button>
        </div>
      </div>
    );

    return (
      <div className="purchase-order-block" data-cy="finance-tax-tab">
        <div className="row">
          <div className="col-12 mt-3">
            <h2 className="content-heading content-heading-lg text-uppercase my-auto me-auto">
              Bank Account Information
            </h2>
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <CustomInput
              {...fields.finance_accountName}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_accountName.name)}
            />
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <CustomInput
              {...fields.finance_bsb}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_bsb.name)}
            />
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <CustomInput
              {...fields.finance_accountNo}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_accountNo.name)}
            />
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <CustomInput
              {...fields.finance_remittance}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_remittance.name)}
            />
          </div>
        </div>
        <div className="row" data-cy="start-sequence-tab">
          <div className="col-12 mt-3">
            <h2 className="content-heading content-heading-lg text-uppercase my-auto me-auto">
              Starting Sequence of Number
            </h2>
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <CustomInput
              {...fields.finance_invoiceNo}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_invoiceNo.name)}
            />
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <CustomInput
              {...fields.finance_purchaseOrderNo}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_purchaseOrderNo.name)}
            />
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <CustomInput
              {...fields.finance_customerNo}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_customerNo.name)}
            />
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <CustomInput
              {...fields.finance_vendorNo}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_vendorNo.name)}
            />
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <CustomInput
              {...fields.finance_projectNo}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_projectNo.name)}
            />
          </div>
        </div>

        {/* Simple Quarter Configuration Section */}
        <div className="row">
          <div className="col-12 mt-3">
            <h2 className="content-heading content-heading-lg text-uppercase my-auto me-auto">
              Quarter Configuration
            </h2>
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <SelectInput
              {...fields.finance_fiscal_year_start_month}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_fiscal_year_start_month.name)}
              data-cy="fiscal-year-start-select"
            />
          </div>
          <div className="col-lg-4 col-md-6 mt-3">
            <CustomInput
              {...fields.finance_months_per_quarter}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_months_per_quarter.name)}
              data-cy="months-per-quarter-input"
            />
          </div>
        </div>

        {/* Invoice Act Text Section */}
        <div className="row" data-cy="act-text-section">
          <div className="col-12 mt-3">
            <h2 className="content-heading content-heading-lg text-uppercase my-auto me-auto">
              Invoice Act Information
            </h2>
          </div>
          <div className="col-lg-2 col-md-3 mt-3">
            <div className="form-group">
              <div className="input-block">
                <label className="input-label">
                  <span className='d-flex gap-1'>
                    {fields.finance_act_placement.label}
                    <span className='text-danger'>*</span>
                  </span>
                </label>
                <div className="placement-radio-container border rounded p-3" data-cy={fields.finance_act_placement.dataCy}>
                  <Form.Check
                    type="radio"
                    id="placement-left"
                    name={fields.finance_act_placement.name}
                    value="left"
                    label="Left"
                    checked={fields.finance_act_placement.value === "left"}
                    onChange={(e) => this.radioChangeHandler(e, fields.finance_act_placement.name)}
                    disabled={!writePermission}
                    className="text-left"
                  />
                  <Form.Check
                    type="radio"
                    id="placement-center"
                    name={fields.finance_act_placement.name}
                    value="center"
                    label="Center"
                    checked={fields.finance_act_placement.value === "center"}
                    onChange={(e) => this.radioChangeHandler(e, fields.finance_act_placement.name)}
                    disabled={!writePermission}
                    className="text-left"
                  />
                  <Form.Check
                    type="radio"
                    id="placement-right"
                    name={fields.finance_act_placement.name}
                    value="right"
                    label="Right"
                    checked={fields.finance_act_placement.value === "right"}
                    onChange={(e) => this.radioChangeHandler(e, fields.finance_act_placement.name)}
                    disabled={!writePermission}
                    className="text-left"
                  />
                </div>
                {fields.finance_act_placement.error && (
                  <small className="float-start text-danger">
                    {fields.finance_act_placement.error}
                  </small>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-10 col-md-9 mt-3">
            <TextAreaInput
              {...fields.finance_act_text}
              disabled={!writePermission}
              onChange={(e) => this.inputChangeHandler(e, fields.finance_act_text.name)}
            />
          </div>
        </div>
        <div className="row" data-cy="act-text-section">
          <div className="col-12 mt-3">
            <h2 className="content-heading content-heading-lg text-uppercase my-auto me-auto">
              Retention/Variation Configuration
            </h2>
          </div>
          <div className="col-12 mt-4">
            <div className="form-group">
              <div className="input-block">
                <label className="input-label d-block mb-2">Visibility</label>
                <div className="row g-3">
                  <div className="col-lg-3 col-md-4 col-sm-6">
                    <Form.Check
                      type="checkbox"
                      id="show-retention-toggle"
                      className="d-flex align-items-center gap-2 mb-0"
                    >
                      <Form.Check.Input
                        type="checkbox"
                        checked={Boolean(fields.finance_show_retentions.value)}
                        name={fields.finance_show_retentions.name}
                        disabled={!writePermission}
                        onChange={(e) => this.inputChangeHandler(e, fields.finance_show_retentions.name)}
                        data-cy={fields.finance_show_retentions.dataCy}
                      />
                      <Form.Check.Label className="mb-0">
                        {fields.finance_show_retentions.label}
                      </Form.Check.Label>
                    </Form.Check>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6">
                    <Form.Check
                      type="checkbox"
                      id="show-variation-toggle"
                      className="d-flex align-items-center gap-2 mb-0"
                    >
                      <Form.Check.Input
                        type="checkbox"
                        checked={Boolean(fields.finance_show_variations.value)}
                        name={fields.finance_show_variations.name}
                        disabled={!writePermission}
                        onChange={(e) => this.inputChangeHandler(e, fields.finance_show_variations.name)}
                        data-cy={fields.finance_show_variations.dataCy}
                      />
                      <Form.Check.Label className="mb-0">
                        {fields.finance_show_variations.label}
                      </Form.Check.Label>
                    </Form.Check>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {writePermission && (<div className="col-12 d-flex mt-3">
          <Button data-cy="save-button" onClick={this.handleFinanceSave} className="ms-auto me-3 secondarybtn">Save</Button>
        </div>)}

        <Modal
          open={showPropagationModal}
          onClose={this.closePropagationModal}
          modalHeading="Apply Visibility Changes to All Projects?"
          modalContent={propagationModalContent}
          showActionBtn={false}
          fullWidth
          maxWidth="sm"
          data-cy="visibility-propagation-modal"
        />

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  globalSetting: state.globalSetting,
});

const mapDispatchToProps = (dispatch) => ({
  getGlobalSetting: bindActionCreators(getGlobalSetting, dispatch),
  editGlobalSetting: bindActionCreators(editGlobalSetting, dispatch),
  errorSnackBar: bindActionCreators(errorSnackBar, dispatch),
  getGlobalSettingReducer: bindActionCreators(
    getGlobalSettingReducer,
    dispatch
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FinanceSetting)
);
